import type { SensorIcon } from "@map/logic";
import { cn } from "@utils";

// How many of the icon's four figures are solid for each status. Without sensor data all four are grey.
const SOLID_FIGURES: Record<SensorIcon, number> = { quiet: 1, lively: 2, busy: 3, full: 4, unknown: 4 };

// From the legacy HaNWorkspaceIcon SVGs: four figures with gaps of half a figure fill the 14 wide view box,
// so a figure is 14 / 5.5 wide and the next one starts 1.5 figures further
const FIGURE_SPACING = 3.8182;
const FIGURE_WIDTH = 2.5455;
const HEAD_RADIUS = FIGURE_WIDTH / 2;

type OccupancyStatusIconProps = {
  status: SensorIcon;
};

// A circle with four figures in it: the more of them are solid, the busier the sensors say the area is.
export const OccupancyStatusIcon = ({ status }: OccupancyStatusIconProps) => {
  return (
    <span
      className={cn("flex size-6 flex-none items-center justify-center rounded-full text-white", {
        "bg-functional-red": status === "full",
        "bg-functional-orange": status === "busy",
        "bg-[#ddbe3b]": status === "lively",
        "bg-functional-green": status === "quiet",
        "border border-mapiq-black-150 bg-mapiq-black-50 text-mapiq-black-400": status === "unknown",
      })}>
      <svg
        aria-hidden
        width="14"
        height="10"
        viewBox="0 0 14 10"
        fill="currentColor">
        {Array.from({ length: 4 }, (_, index) => {
          const left = index * FIGURE_SPACING;

          return (
            <g
              key={index}
              fillOpacity={index < SOLID_FIGURES[status] ? 1 : 0.4}>
              <circle
                cx={left + HEAD_RADIUS}
                cy={1.606}
                r={HEAD_RADIUS}
              />
              <path d={`M${left} 5a${HEAD_RADIUS} ${HEAD_RADIUS} 0 0 1 ${FIGURE_WIDTH} 0v4.6667h-${FIGURE_WIDTH}z`} />
            </g>
          );
        })}
      </svg>
    </span>
  );
};
